export default "__VITE_ASSET__fWi8F0o7__"